<template>
  <v-layout row justify-center>
    <v-dialog v-model="openAttachmentPop" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.prevent="closePopup()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Resources</v-toolbar-title>
        </v-toolbar>
          <attachment-resources></attachment-resources>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import store from '@/store';
export default {
  name: 'AttachmentPopup',
  data() {
    return {

    }
  },
  mounted() {
    
  },
  computed: {
    openAttachmentPop() {
      return this.$store.getters.getAttachmentPopup;
    }
  },
  methods:{
   closePopup() {
      this.$store.dispatch("SET_ATTACHMENT_POPUP", false);
    }
  }

}
</script>